
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Mit diesem Thema hat sich unter anderem die Münchner Schlafforscherin Dr. Barbara Knab auseinandergesetzt. `}<M mdxType="M">{`Damit wir einschlafen können, sollte ihrer Meinung nach die Körpertemperatur um ein knappes Grad Celsius sinken.`}</M>{` Um das zu erreichen, muss überschüssige Wärme auch über unsere Hände und Füsse aus dem Körperinneren weichen. Dieser Mechanismus funktioniert aber nicht bei eiskalten Füssen im Bett, so Knab. Die Blutgefässe sind dort zu eng, sodass zu wenig Blut ankommt, um die Wärme nach aussen abgeben zu können. Wer das Problem kennt, sollte vor dem Zu-Bett-Gehen etwas gegen die kalten Füsse tun. Ein warmes Fussbad, eine kurze Massage, ein Schaffell oder eine Wärmeflasche könnten helfen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;